import { useRecordConsentMutation } from '../../features/apis/complianceApi';

type TermsModalProps = {
  isOpen: boolean;
  setIsTermsOpen: (open: boolean) => void;
};

export default function TermsModal({
  isOpen,
  setIsTermsOpen,
}: TermsModalProps) {
  const [recordConsent, { isLoading }] = useRecordConsentMutation();

  const handleAccept = async () => {
    localStorage.setItem('termsAccepted', 'true');
    try {
      await recordConsent({
        consentType: 'terms',
        version: '1.0',
        given: true,
      }).unwrap();
    } catch (err) {
      console.error('Failed to record consent', err);
    }
    setIsTermsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col items-end">
      <div className="bg-white rounded-lg shadow-lg max-w-sm w-full p-5 font-inter">
        <h2 className="text-xl font-semibold">Welcome to TARA TMS</h2>
        <p className="my-2 text-sm">
          By continuing, you agree to our Terms of Service and Privacy Policy.
          Please read carefully before proceeding.
        </p>
        <p className="mb-1 text-xs text-gray-600">
          We process personal data for attendance, payroll, and communication.
          You may request export or deletion via Compliance pages.
        </p>
        <p className="mb-3 text-xs">
          <a
            href="/terms-and-conditions"
            target="_blank"
            className="text-[#6E3EF5] underline"
          >
            Read More
          </a>
        </p>
        <div className="flex justify-end">
          <button
            onClick={handleAccept}
            disabled={isLoading}
            className="bg-[#6E3EF5] text-white px-2 text-sm py-2 rounded hover:bg-[#5B2ED9] disabled:opacity-60"
          >
            {isLoading ? 'Accepting...' : 'Accept & Continue'}
          </button>
        </div>
      </div>
    </div>
  );
}
